(ns bp-libs.design-system.components.text-input
  (:require [bp-libs.design-system.components.icons :as icons]))

(defn single-line-input-text
  {:storybook {:value {:name         "Text value"
                       :type         {:name "string" :required false}
                       :defaultValue "some text.."
                       :control      {:type "text"}}}}
  [{:keys [value on-change class]}]
  [:div {:class ["-mr-3" class]}
   [:div {:class "relative"}
    [:div {:class ["w-full"
                   "bg-gray-900 text-gray-50 text-4xl font-semibold"
                   "rounded focus-within:outline focus-within:outline-gray-50"
                   "flex items-center space-x-2 mt-4"
                   "inset-y-0 left-0"
                   "items-center"]}
     [icons/search {:class "ml-4 z-0"}]
     [:input {:type "search"
              :value value
              :on-change on-change
              :class ["bg-gray-900 text-gray-50 text-4xl font-semibold"
                      "p-4 outline-none"
                      "w-full"
                      "block"
                      "rounded"
                      "selection:bg-green-500 border border-none"]}]]]])
